// react & redux
import React from "react";
// antd
// util
// component
import {Form, Radio} from "antd";
import Table from "../../custom/table/Table";
import Pagination from "../../custom/pagination/Pagination";
import OptionSort from "../../component/optionsort/OptionSort";
import UserSelect from "../../component/user/UserSelect";
import DragDemo from "../../component/dnd/DragDemo";
// style
// asset
// other
// action

class TestView extends React.Component {
    constructor(...args) {
        super(...args);
        this.columns = [
            {
                title: "Full Name",
                width: 100,
                dataIndex: "name",
                key: "name",
                fixed: "left",
            },
            {
                title: "Age",
                width: 100,
                dataIndex: "age",
                key: "age",
                fixed: "left",
            },
            {
                title: "Column 1",
                dataIndex: "address",
                key: "1",
                width: 150,
            },
            {
                title: "Column 2",
                dataIndex: "address",
                key: "2",
                width: 150,
            },
            {
                title: "Column 3",
                dataIndex: "address",
                key: "3",
                width: 150,
            },
            {
                title: "Column 4",
                dataIndex: "address",
                key: "4",
                width: 150,
            },
            {
                title: "Column 5",
                dataIndex: "address",
                key: "5",
                width: 150,
            },
            {
                title: "Column 6",
                dataIndex: "address",
                key: "6",
                width: 150,
                // children: [
                //     {
                //         title: "Column 6-1",
                //         key: "6-1",
                //         width: 75,
                //         render: () => {
                //             return "6-1"
                //         }
                //     },
                //     {
                //         title: "Column 6-2",
                //         key: "6-2",
                //         width: 75,
                //         render: () => {
                //             return "6-2"
                //         }
                //     },
                // ],
            },
            {
                title: "Column 7",
                dataIndex: "address",
                key: "7",
                width: 150,
            },
            {title: "Column 8", dataIndex: "address", key: "8", width: 200},
            {
                title: "Action",
                key: "operation",
                fixed: "right",
                width: 100,
                render: () => <a>action</a>,
            },
        ];
        const data = [];
        for (let i = 0; i < 100; i++) {
            data.push({
                key: i,
                name: `Edrward ${i}`,
                age: 32,
                address: `London Park no. ${i}`,
            });
        }
        this.data = data;
        this.state = {
            value: "normal",
        };
    }

    renderTable() {
        const {value} = this.state;
        return (
            <div
                style={{
                    flex: 1,
                    display: "flex",
                }}
            >
                <Table
                    columns={this.columns}
                    dataSource={this.data}
                    type={value}
                />
            </div>
        );
    }

    renderOptionSort() {
        return (
            <OptionSort
                // onChange={val => console.log(val)}
                onEditingChange={(editing) => {
                    if (editing) {
                        console.log("编辑开始");
                    } else {
                        console.log("编辑结束");
                    }
                }}
            />
        );
    }

    render() {
        return (
            <div
                style={{
                    display: "flex",
                    flex: "1",
                    flexDirection: "column",
                    padding: "10px 12px",
                }}
            >
                <DragDemo />
                {/* <Form> */}
                {/*    <Form.Item */}
                {/*        name="users" */}
                {/*        label="人员选择" */}
                {/*        rules={[{ required: true, message: '必填' }]} */}
                {/*    > */}
                {/*        <UserSelect */}
                {/*            style={{ */}
                {/*                width: 504, */}
                {/*            }} */}
                {/*        /> */}
                {/*    </Form.Item> */}
                {/* </Form> */}
                {/* <Radio.Group onChange={e => { */}
                {/*                 this.setState({ */}
                {/*                     value: e.target.value, */}
                {/*                 }) */}
                {/*             }} */}
                {/*             value={this.state.value} */}
                {/*             style={{ */}
                {/*                 marginBottom: 16 */}
                {/*             }} */}
                {/* > */}
                {/*    <Radio.Button value="normal">table-default</Radio.Button> */}
                {/*    <Radio.Button value="background">table-diff-background</Radio.Button> */}
                {/*    <Radio.Button value="bordered">table-bordered</Radio.Button> */}
                {/*    <Radio.Button value="optionsort">optionSort</Radio.Button> */}
                {/* </Radio.Group> */}
                {/* { */}
                {/*    this.state.value === "optionsort" */}
                {/*        ? this.renderOptionSort() */}
                {/*        : this.renderTable() */}
                {/* } */}
            </div>
        );
    }
}

export default TestView;
